import DoneIcon from '@mui/icons-material/Done';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import TimerIcon from '@mui/icons-material/Timer';
import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import STATUS from '../../services/analyses/status';

const iconClasses = {
    fontSize: '1rem',
};
const iconByStatus = {
    finished: <DoneIcon sx={iconClasses} />,
    failed: <ErrorOutlineIcon sx={iconClasses} />,
    initial: <TimerIcon sx={iconClasses} />,
};

const labelByStatus = {
    finished: 'finished',
    failed: 'failed',
    initial: 'running',
};

const Status = ({ status }) => {
    return (
        <Box
            sx={{
                px: 1,
                minWidth: '86px',
                borderRadius: 12,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                flex: '0 1 auto',
                flexDirection: 'row',
                gap: 1 / 2,
                m: 1,
                ...(status === STATUS.FINISHED && {
                    backgroundColor: 'success.main',
                }),
                ...(status === STATUS.FAILED && {
                    backgroundColor: 'error.main',
                    color: 'white.light',
                    gap: 1,
                }),
            }}
        >
            {iconByStatus[status]}
            <Typography variant="subtitle2" component="p">
                {labelByStatus[status]}
            </Typography>
        </Box>
    );
};

Status.propTypes = {
    status: PropTypes.string.isRequired,
};

export default Status;
